<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
            <div class="container">
                <div class="page-banner-content">
                    <h1>NSS</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Student Corner</li>
                        <li>Cells</li>
                        <li>NSS</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--End Page Banner-->

        <!--Start NSS Area-->
        <div class="privacy-policy-area pt-100 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="privacy-content pr-20">
                            <h2>NSS</h2>
                            <p>National Service Scheme in College is an active program run by the Ministry of Youth Affairs and Sports, Government of India for the personality development of the youth of the Nation.</p>
                            <p>Through this unit, the college students work together with the people of the society in the interest of the society. It works on the basis of <strong>'I, not you'</strong> plan. It was started in 1969. This day is celebrated every year on 24 September.</p>
                            <p>Through NSS, we prepare youth to serve the Nation through various activities and sensitize people at the local level towards environment, cleanliness, education and various diseases. act of awareness</p>

                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="privacy-left-content pl-20">
                            <div class="team-img-box"> <img width="460" height="500"
                                    src="/vf/images/cells/C2_inner.png"
                                    class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                    decoding="async" fetchpriority="high"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--End NSS Area-->


        <!-- Start Bottom Connect Area -->
         <div class="alumni-interview-area pb-100">
            <div class="container">
                <div class="interview-content ptb-100">
                    <div class="interview">
                        <a href="https://rdc.eshala.co.in/events" class="default-btn btn">Events<i
                                class="flaticon-next"></i></a>
                        <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn">Apply Now<i
                                class="flaticon-next"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <!--End Bottom Connect Area -->
</template>

<script>
export default {
    name : "WDCView"
};
</script>
